/**
 * API configuration for the voice search application
 * Contains API base URL, WebSocket URL, and authentication credentials
 * Uses dynamic environment settings if available, otherwise falls back to static environment variables
 */
export const getApiConfig = () => {
    if (window.__VOICE_SEARCH_ENV_SETTINGS__) {
        return {
            API_BASE_URL: window.__VOICE_SEARCH_ENV_SETTINGS__.REACT_APP_API_BASE_URL,
            WEBSOCKET_URL: process.env.REACT_APP_WEBSOCKET_URL,
            clientKey: window.__VOICE_SEARCH_ENV_SETTINGS__.REACT_APP_CLIENT_KEY,
            accessKey: window.__VOICE_SEARCH_ENV_SETTINGS__.REACT_APP_ACCESS_KEY,
            accessSecret: window.__VOICE_SEARCH_ENV_SETTINGS__.REACT_APP_ACCESS_SECRET,
            profileImageUrl: window.__VOICE_SEARCH_ENV_SETTINGS__.PROFILE_IMAGE_URL,
            carouselData: window.__VOICE_SEARCH_ENV_SETTINGS__.CAROUSEL_DATA,
            phrases:window.__VOICE_SEARCH_ENV_SETTINGS__.PHRASES,
            is_use_pick_slider:window.__VOICE_SEARCH_ENV_SETTINGS__.is_use_pick_slider,
            trialPeriod:window.__VOICE_SEARCH_ENV_SETTINGS__.TRIAL_PERIOD
        };
    }

    return {
        API_BASE_URL: process.env.REACT_APP_API_BASE_URL,
        WEBSOCKET_URL: process.env.REACT_APP_WEBSOCKET_URL,
        clientKey: process.env.REACT_APP_CLIENT_KEY,
        accessKey: process.env.REACT_APP_ACCESS_KEY,
        accessSecret: process.env.REACT_APP_ACCESS_SECRET,
        profileImageUrl: '',
        carouselData:'',
        phrases:'',
        trialPeriod:''

    };
};

export default getApiConfig;
